<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <PageTemplate v-if="title && !loading" class="item" :title="title">
        <div class="pt-10 pt-md-14 pt-lg-16">
          <v-sheet
            :width="smAndDown ? '100%' : '50%'"
            class="float-md-left pr-md-7 py-md-10"
          >
            <GallerySlidesWidget v-if="img.length" :images="img" />

            <IconsWidget
              v-if="icons.length && !smAndDown"
              class="pt-7"
              :icons="icons"
            />

            <slot v-if="!smAndDown" name="pricing-table" />
          </v-sheet>

          <div class="pt-10">
            <div class="text-center">
              <ButtonWidget @click="scrollTo($refs.team)">
                Faça sua Reserva
              </ButtonWidget>
            </div>

            <div class="ck-content pt-7" v-html="text"></div>

            <slot v-if="smAndDown" name="pricing-table" />
          </div>

          <slot name="more-content" />
        </div>

        <div ref="team">
          <TeamSection title="Fale com um Consultor" />
        </div>
      </PageTemplate>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import PageTemplate from "./PageTemplate.vue";
import GallerySlidesWidget from "../widgets/GallerySlidesWidget.vue";
import IconsWidget from "../widgets/IconsWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";
import TeamSection from "../sections/TeamSection.vue";
import { scrollTo } from "../../utils/scrollTo";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    img: {
      type: Array,
      default: () => [],
    },
    icons: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    scrollTo,
  },
  components: {
    LoadingWidget,
    PageTemplate,
    GallerySlidesWidget,
    IconsWidget,
    ButtonWidget,
    TeamSection,
  },
};
</script>

<style lang="scss" scoped>
.item::v-deep {
  .pricing-table {
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  .img-payment-method {
    border: 2px solid #dddddd;
    -o-object-fit: contain;
    object-fit: contain;
  }
}
</style>
